import axios from 'axios';

export const getApprovePhaseList = () => axios.get(`/withdraw_approval_system/phase/list/`);
export const mutateApprovePhase = payload => axios.post(`/withdraw_approval_system/phase/mutate/`, [...payload]);
export const deleteApprovePhase = phaseId => axios.delete(`/withdraw_approval_system/phase/${phaseId}/`);
